import { render, staticRenderFns } from "./GroupDialog.vue?vue&type=template&id=e2133332&scoped=true&"
import script from "./GroupDialog.vue?vue&type=script&lang=ts&"
export * from "./GroupDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2133332",
  null
  
)

export default component.exports